<template>
    <div class="product-h6">
        <div class="item-one">
            <img src="../../../assets/img/product/yd1.png" alt="">
        </div>
        <div class="item-one">
            <img src="../../../assets/img/product/yd2.png" alt="">
        </div>
        <div class="productImg">
            <div class="itemTitle">定制桌面APK <span style="color: #2e2e2e; font-size: 20px;font-weight: 400;">（鼠标移至图片即可预览）</span></div>
            <div class="ingItem">
                <div @mouseover="mouseOver(1,11)" @mouseout="mouseout(1,111)">
                    <img :src="src1" alt="">
                </div>
                <div class="itemRight" @mouseover="mouseOver(2,22)" @mouseout="mouseout(2,222)">
                    <img :src="src2" alt="">
                </div>
            </div>
            <div class="ingItem">
                <div @mouseover="mouseOver(3,33)" @mouseout="mouseout(3,333)">
                    <img :src="src3" alt="">
                </div>
                <div class="itemRight" @mouseover="mouseOver(4,44)" @mouseout="mouseout(4,444)">
                    <img :src="src4" alt="">
                </div>
            </div>
            <div class="ingItem">
                <div @mouseover="mouseOver(5,55)" @mouseout="mouseout(5,555)">
                    <img :src="src5" alt="">
                </div>
                <div class="itemRight" @mouseover="mouseOver(6,66)" @mouseout="mouseout(6,666)">
                    <img :src="src6" alt="">
                </div>
            </div>
            <div class="ingItem">
                <div @mouseover="mouseOver(7,77)" @mouseout="mouseout(7,777)">
                    <img :src="src7" alt="">
                </div>
                <div class="itemRight" @mouseover="mouseOver(8,88)" @mouseout="mouseout(8,888)">
                    <img :src="src8" alt="">
                </div>
            </div>
            <div class="ingItem">
                <div @mouseover="mouseOver(9,99)" @mouseout="mouseout(9,999)">
                    <img :src="src9" alt="">
                </div>
                <div class="itemRight" @mouseover="mouseOver(10,1010)" @mouseout="mouseout(10,101010)">
                    <img :src="src10" alt="">
                </div>
            </div>
        </div>
		<div class="item-one">
			<img src="./yd/1.jpg" />
		</div>
		<div class="item-one">
			<img src="./yd/2.jpg" />
		</div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                src1:require('../../../assets/img/product/gif11.jpg'),
                src11:require('../../../assets/img/product/gif1.gif'),
                src111:require('../../../assets/img/product/gif11.jpg'),
                src2:require('../../../assets/img/product/gif22.jpg'),
                src22:require('../../../assets/img/product/gif2.gif'),
                src222:require('../../../assets/img/product/gif22.jpg'),
                src3:require('../../../assets/img/product/gif33.jpg'),
                src33:require('../../../assets/img/product/gif3.gif'),
                src333:require('../../../assets/img/product/gif33.jpg'),
                src4:require('../../../assets/img/product/gif44.jpg'),
                src44:require('../../../assets/img/product/gif4.gif'),
                src444:require('../../../assets/img/product/gif44.jpg'),
                src5:require('../../../assets/img/product/gif55.jpg'),
                src55:require('../../../assets/img/product/gif5.gif'),
                src555:require('../../../assets/img/product/gif55.jpg'),
                src6:require('../../../assets/img/product/gif66.jpg'),
                src66:require('../../../assets/img/product/gif6.gif'),
                src666:require('../../../assets/img/product/gif66.jpg'),
                src7:require('../../../assets/img/product/gif77.jpg'),
                src77:require('../../../assets/img/product/gif7.gif'),
                src777:require('../../../assets/img/product/gif77.jpg'),
                src8:require('../../../assets/img/product/gif88.jpg'),
                src88:require('../../../assets/img/product/gif8.gif'),
                src888:require('../../../assets/img/product/gif88.jpg'),
                src9:require('../../../assets/img/product/gif99.jpg'),
                src99:require('../../../assets/img/product/gif9.gif'),
                src999:require('../../../assets/img/product/gif99.jpg'),
                src10:require('../../../assets/img/product/gif1010.jpg'),
                src1010:require('../../../assets/img/product/gif10.gif'),
                src101010:require('../../../assets/img/product/gif1010.jpg'),
            }
        },
        methods: {
            mouseOver(e,f){
                this[`src${e}`] = this[`src${f}`]
            },
            mouseout(e,f){
                this[`src${e}`] = this[`src${f}`]
            }
        },
    }
</script>

<style scoped>
    .product-h6 {
        width: 100%;
        background-color: #fff;
    }
    .product-h6 .item-one{
        width: 100%;
        height: auto;
    }
    .product-h6 .item-one img{
        width: 100%;
        height: auto;
    }
    .productImg{
        padding: 30px;
    }
    .itemTitle{
        font-size: 20px;
        font-family: 微软雅黑;
        color: #f2a726;
        font-weight: bold;
        margin-left:28px;
    }
    .ingItem{
        display: flex;
        justify-content: space-around;
        margin:30px;
    }
    .ingItem div{
        width: 472px;
        height: 268px;
    }
    .ingItem img{
        width: 100%;
        height: 100%;
    }
    .itemRight{
        margin-left: 20px;
    }
</style>